import { IValidator, randomId, validateClassName } from "@sebgroup/extract";
import { ReactNode } from "react";
import classNames from "classnames";
import { FormItemsProps } from "@sebgroup/green-react";
import InfoCircle from "../Icons/InfoCircleIcon";
import IconButton from "../IconButton/IconButton";

interface GreenFormItemProps extends FormItemsProps {
  id?: string;
  label?: string;
  labelInformation?: string | ReactNode;
  validator?: IValidator;
  slideoutButtonLabel?: string;
  inputId?: string;
  children: ReactNode;
  role?: string;
  footer?: ReactNode;
  onSlideoutButtonClick?: () => void;
}

function GreenFormItem({
  id,
  label,
  labelInformation,
  validator,
  slideoutButtonLabel,
  onSlideoutButtonClick,
  inputId,
  children,
  role,
  footer,
}: GreenFormItemProps) {
  if (!inputId) inputId = randomId();

  const greenFormItemClassNames = classNames("gds-form-item", validator && validateClassName(validator?.indicator));

  return (
    <div id={id} className={greenFormItemClassNames} role={role} aria-labelledby={role ? `${inputId}-label` : undefined}>
      <div className="gds-form-item__header">
        <div className="gds-form-item__labels">
          {label && (
            <label id={role ? `${inputId}-label` : undefined} htmlFor={role ? undefined : inputId}>
              {label}
            </label>
          )}
          {labelInformation && (
            <div className="form-info" id={`${inputId}_info`}>
              {labelInformation}
            </div>
          )}
        </div>
        {onSlideoutButtonClick && (
          <IconButton
            data-testid={`${inputId}-slideout-button__testid`}
            aria-expanded={false}
            aria-controls={`${inputId}-slider-info`}
            onClick={onSlideoutButtonClick}
          >
            <InfoCircle title={slideoutButtonLabel} />
          </IconButton>
        )}
      </div>
      {children}
      <div className="gds-form-item__footer">
        {validator && (
          <span className="form-info" id={`${inputId}_error`}>
            {validator.message}
          </span>
        )}
      </div>
      {/* TODO: this is not in the right place due to hacky css. */}
      {footer}
    </div>
  );
}

export default GreenFormItem;
